import { ArrowForwardIos } from '@mui/icons-material';
import { ListItem, ListItemAvatar, ListItemText, Paper } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import StatusIcon from '../StatusIcon/StatusIcon';

export default function OrderListItem({ order, isDisabled }) {
	const { name, dateOfDelivery, status, id } = order;
	const navigate = useNavigate();

	return (
		<>
			<Paper elevation={3} sx={{ mt: '8px' }}>
				<ListItem
					button
					onClick={() => navigate(`/${id}/view`)}
					disabled={isDisabled} // ? Quitarlo despues de pruebas
				>
					<ListItemAvatar>
						<StatusIcon status={status} />
					</ListItemAvatar>
					<ListItemText
						primary={name}
						secondary={`Entrega:  ${dayjs(dateOfDelivery).format(
							'DD/MM/YYYY hh:mm A'
						)}`}
					/>
					<ArrowForwardIos color='secondary' />
				</ListItem>
			</Paper>
		</>
	);
}
